export const LangEn = {
    name:'en',
    data:{
        'pageTitles': {
            'loginTempWorker': "Temp worker login — Jobbiz",
            'loginCompany': "Company login — Jobbiz",
            'registerTempWorker': "Temp worker sign-up — Jobbiz",
            'forgot': "Forgotten password — Jobbiz",
            'resetPassword': "Reset password — Jobbiz",
            'invitation': "Invitation — Jobbiz",
            'finalizeAccount': "Complete my account — Jobbiz",
            'finalizeRegistration': "Complete my sign-up — Jobbiz",
            'fallback': "Jobbiz - digital temp work agency"
        },
        "modalExp":{
            "name":"kd,mkdmdké"
        },
        "name":'Ceci est un test',
        map : new Map()
    }
}